/**
 * @description Base SwatchCarouselSwiper implementation
 * @param CarouselSwiper Base widget for extending
 * @returns SwatchCarouselSwiper widget
 */
function SwatchCarouselSwiperClassCreator(CarouselSwiper: import('widgets/global/CarouselSwiper').TCarouselSwiper) {
    /**
     * @category widgets
     * @subcategory product
     * @class SwatchCarouselSwiper
     */
    class SwatchCarouselSwiper extends CarouselSwiper {
        prefs() {
            return {
                ...super.prefs(),
                loop: false,
                spaceBetween: 12,
                slidesPerView: 5,
                slidesPerViewMobile: 6,
                slidesPerViewDesktop: 9,
                slidesPerGroup: 3,
                slidesPerGroupMobile: 4,
                slidesPerGroupDesktop: 7
            };
        }

        getOptions() {
            const prefs = this.prefs();
            const baseOptions = super.getOptions();

            return {
                ...baseOptions,
                breakpoints: {
                    ...baseOptions.breakpoints,
                    767: {
                        slidesPerGroup: prefs.slidesPerGroupMobile,
                        ...baseOptions.breakpoints?.[767]
                    },
                    1179: {
                        slidesPerView: prefs.slidesPerViewDesktop,
                        slidesPerGroup: prefs.slidesPerGroupDesktop
                    }
                }
            };
        }
    }

    return SwatchCarouselSwiper;
}

export type TSwatchCarouselSwiper = ReturnType<typeof SwatchCarouselSwiperClassCreator>;

export type TSwatchCarouselSwiperInstance = InstanceType<TSwatchCarouselSwiper>;

export default SwatchCarouselSwiperClassCreator;
